import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const isMobile = () => window.innerWidth <= 768;

export function sweetAlert(options = {}) {
  const { title, text, icon = 'info', position, width, ...rest } = options;
  const mobile = isMobile();
  return MySwal.fire({
    title,
    text,
    icon,
    ...rest,
    width: mobile ? '100%' : width,
    position: mobile ? 'bottom' : position || 'center',
  });
}

// Preset Moderne : l'alerte s'ouvre dans le formulaire (target) pour hériter de ses variables --af-*, et ses boutons
// prennent les classes des boutons du formulaire au lieu des couleurs de SweetAlert
export function modernAlertOptions(target) {
  if (!target) return {};
  return {
    target,
    buttonsStyling: false,
    customClass: {
      container: 'af-alert',
      confirmButton: 'af-form-button',
      cancelButton: 'af-form-button return',
    },
  };
}
